/**
 * Shared Live/Removed/etc. status filter control so the Google ad table and the
 * ADSP entity tree offer identical status buckets from one definition, keeping
 * their server-filter options from drifting apart.
 */
import React from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';
import { useTranslation } from 'src/arb-wrapper';
import type { AdsStatusFilter } from './statusFilterParams';

interface StatusFilterSelectProps {
  testId?: string;
  value: AdsStatusFilter;
  width?: number;
  onChange: (value: AdsStatusFilter) => void;
}

export const StatusFilterSelect: React.FC<StatusFilterSelectProps> = ({
  onChange,
  testId = 'ads-manager-status-filter',
  value,
  width = 140,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      data-testid={testId}
      size="small"
      value={value}
      width={width}
      onChange={onChange}
    >
      <SelectOption label={t('ads_manager_filter_all')} value="ALL" />
      <SelectOption label={t('ads_manager_filter_live')} value="LIVE" />
      <SelectOption label={t('ads_manager_filter_pending')} value="PENDING" />
      <SelectOption label={t('ads_manager_filter_processing')} value="PROCESSING" />
      <SelectOption label={t('ads_manager_filter_failed')} value="FAILED" />
      <SelectOption label={t('ads_manager_filter_removed')} value="REMOVED" />
    </Select>
  );
};
